import { render, staticRenderFns } from "./FullWidthImage.vue?vue&type=template&id=3d4f93a9&scoped=true&"
import script from "./FullWidthImage.vue?vue&type=script&lang=js&"
export * from "./FullWidthImage.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthImage.vue?vue&type=style&index=0&id=3d4f93a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4f93a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
